import APP from 'app';
import moment from 'moment';
const { Utils } = APP;
import Constants from 'constants';
import commonConst from './../../../constants/common';
const { formatPrice, properCase, isJsonString,dateCountryPopupCheck } = Utils;
const { dynamicBookingNotes = [] } = APP.Utils.getConfig();
const { BOOKING_NOTES_INSTRUCTION = {} } = commonConst;


//For AGODA, we don't want to show following types in booking notes as we're showing them separately
const filterInstTypesArr = ['CHILD_AND_BED_POLICY', 'INCLUSION_EXCLUSION', 'BENEFITS'];
const filterInstTypes = (inst = []) => inst.filter((instruction = {}) => {
    const { type = '' } = instruction;
    return !(filterInstTypesArr.includes(type));
});

const getFormattedMessage = (msg, type) => {
    let message = msg;
    switch (type) {
        case "INCLUSIONS": message = msg.split('--').join(' , ');
    }
    if (isJsonString(message)) {
        const json = JSON.parse(message);
        const headers = Object.keys(json);
        message = headers.map(header => `<b>${properCase(header)}</b> : ${json[header]}`).join(' ');
    }
    return message;
}

const checkMult = (arr, name, price) => {
    return arr.findIndex((val) => {
        const { rc = '', tp = '' } = val;
        return (rc === name && tp === price);
    });
}

const calculateTaxAmount = (ris = []) => {
    let _additionalTax = {
        MNT: 0,
        TSF: 0,
        ST: 0
    };
    ris.map((el) => {
        const { tfcs = {}, tafcs = {} } = el,
            { TAF = {} } = tafcs,
            { MNT = 0, TSF = 0, ST = 0 } = TAF;
        _additionalTax.MNT += _additionalTax.MNT + MNT;
        _additionalTax.TSF += _additionalTax.TSF + TSF;
        _additionalTax.ST += _additionalTax.ST + ST;
    });
    return _additionalTax
}

/**
 * 
 * @param {boolean} opsLev 
 * @param {array or string} value 
 * @param {string} checkinDate 
 * 
 * dynamicBookingNotes should be in format of
 * 
 * {
 *  checkInFrom: '2020-12-01',
 *  checkInTo: '2021-01-03',
 *  notes: []
 *  }
 */
export const getAdditionalBookingNotes = (opsLev, value, checkinDate) => {
    let newValue = [];
    dynamicBookingNotes.forEach(bookingNote => {
        const { checkInFrom = '', checkInTo = '', notes = [] } = bookingNote;
        const startDate = moment(checkInFrom, Constants.common.DATE_ISO_FORMATS.DATE);
        const endDate = moment(checkInTo, Constants.common.DATE_ISO_FORMATS.DATE);
        const compareDate = moment(checkinDate, Constants.common.DATE_ISO_FORMATS.DATE);
        if (compareDate.isBetween(startDate, endDate) || compareDate.isSame(startDate) || compareDate.isSame(endDate)) {
            const note = notes.map(data => ({ roomName: '', notes: `<b class="highlight_words">${data}</b>` }));
            newValue = [...note, ...newValue];
        }
    });
    if (opsLev) {
        newValue = newValue.map(data => data.notes);
        return [...newValue, value].reduce((accum, note) => { return `${accum} ${note}` }, '');
    } else {
        return [...newValue, ...value];
    }
}

export const makeBookingNotes = (options, value, ris) => {
    const { nt = '', inst = [], ss = [], selectedOption = {}, checkinDate = '',ad ={} } = options;
    const{country = {} } = ad;
    const {name: countryName = ''} = country;

    let opsLev = false,
        expTax = {},
        noData = true;
    const note = nt || value;
    if (note) {
        opsLev = true;
        noData = false;
        return {
            val: { value: getAdditionalBookingNotes(opsLev, note, checkinDate), noData },
            opsLev
        }
    }
    let data = '';
    expTax = calculateTaxAmount(ris);
    const { MNT = 0, ST = 0, TSF = 0 } = expTax;
    const { inst: opsDataInst = [] } = selectedOption;
    data = filterInstTypes(inst).map(instruction => {
        const { type = '', msg = '' } = instruction;
        if (msg) {
            noData = false
        }
        return {
            roomName: type == 'BOOKING_NOTES' ? '' : properCase(type),
            notes: getFormattedMessage(msg, type)
        }
    });
    if(dateCountryPopupCheck(countryName, checkinDate)){
        opsDataInst.push(BOOKING_NOTES_INSTRUCTION)
    }

    filterInstTypes(opsDataInst).forEach(instruction => {
        noData = false;
        const { type = '', msg = '', al = [] } = instruction;
        //This is done since we get all room notes in same booking notes. We split it with new line.
        if (ss.includes('HOTELBEDS')) {
            const _msg = msg.split('/n');
            _msg.forEach(message => {
                data.unshift({
                    roomName: type == 'BOOKING_NOTES' ? '' : `${properCase(type)} ${al.length ? `( ${al.join(',')} )` :''}`,
                    notes: getFormattedMessage(message, type)
                });
            })
        } else {
            data.unshift({
                roomName: type == 'BOOKING_NOTES' ? '' : `${properCase(type)} ${al.length ? `( ${al.join(',')} )` :''}`,
                notes: getFormattedMessage(msg, type)
            });
        }

    });
    if (noData) {
         ris.map(room => {
            const { notes = '', rc = '' } = room;
            if (notes) {
                noData = false
               data.push({
                    roomName: rc,
                    notes
                })
            }
        });
    }
    data = getAdditionalBookingNotes(opsLev, data, checkinDate);
    return {
        val: { value: data, noData: data.length == 0 },
        opsLev,
        additionalTaxes: expTax
    }
};



export const prepareRis = (arr) => {
    let returnData = [];
    return arr.reduce((acc, data) => {
        const { rc = '', tp = '' } = data,
            duplIndex = checkMult(acc, rc, tp);
        if (duplIndex !== -1) {
            const { num, ...rest } = returnData[duplIndex];
            returnData.splice(duplIndex, 1);
            returnData = [
                ...returnData, { ...rest, num: num + 1 }
            ];
        } else {
            returnData = [...returnData, { ...data, num: 1 }];
        }
        return returnData;
    }, []);
}

export const prepareChildAndBedPolicyData = (inst = [], iexb = false) => {
    const childAndBedPolicy = inst.find((instruction = {}) => {
        const { type = '' } = instruction;
        if (type === 'CHILD_AND_BED_POLICY') return true;
    }) || {};
    const { msg = '', type = '' } = childAndBedPolicy;
    return msg ? { type, val: JSON.parse(msg), iexb } : { iexb };
}

export const prepareSurchargePolicyData = (opsInst = []) => {
    const surchargeData = opsInst.find((opsInstData = {}) => {
        const { type = '' } = opsInstData;
        return type === 'INCLUSION_EXCLUSION'
    }) || {};
    const { type = '', msg = '' } = surchargeData;
    if (!type) return [];
    return JSON.parse(msg) || [];
}

export const makeCancellationArr = (cnp = {}, ops = []) => {
    if ('pd' in cnp) {
        const { pd = [] } = cnp;
        return { val: pd, opsLev: true };
    }

    const [firstOps = {}] = ops;
    const { rcnp = [], id: cancellationId = '' } = cnp;
    const { ris = [] } = ops.find((option = {}) => cancellationId === option.id) || firstOps;

    const roomCancellationValues = rcnp.map((room = {}) => {
        const { id: roomId = '' } = room;
        const { rc: roomName = '' } = ris.find((roomInfo = {}) => roomId === roomInfo.id) || {};
        return { ...room, roomName };
    });
    return { val: roomCancellationValues, opsLev: false }
};

export const prepareBenefitsData = (opsInst = []) => {
    return opsInst.find((opsInstData = {}) => {
        const { type = '' } = opsInstData;
        return type === 'BENEFITS'
    }) || {}
};
